import {
  ACCEPT,
  cardText,
  GRAMMAR,
  LANGUAGE,
  PLAGIARISM,
  REJECT,
} from '@src/components/Cards/constants'
import { CheckCategory, EXPERT_CHECK } from '@src/state/document/types'
import { ModalNames, PLAGIARISM_SOURCES_MODAL } from '@src/state/modals/actions'
import { COPIED, Toast } from '@src/state/workspace/reducer'
import { COMPLETED, FAILED, RUNNING, Status } from '@src/types/checks'
import * as Ids from '.'

export const getTestIdOnModalClose = (name: ModalNames) => {
  switch (name) {
    case PLAGIARISM_SOURCES_MODAL:
      return Ids.CLOSE_COPIED_MESSAGE
    default:
      return Ids.MODAL_CLOSE_DEFAULT
  }
}

export const getCloseToastTestId = (type: Toast) =>
  type === COPIED ? Ids.CLOSE_COPIED_MESSAGE : ''

export const getNavTabTestId = (type: CheckCategory) => {
  switch (type) {
    case GRAMMAR:
      return Ids.GRAMMAR_TOGGLE
    case PLAGIARISM:
      return Ids.PLAGIARISM_TOGGLE
    case EXPERT_CHECK:
      return Ids.EXPERT_CHECK_TOGGLE
    default:
      return ''
  }
}

export const getCardRejectTestId = (rejectText: string) => {
  switch (rejectText) {
    case cardText[PLAGIARISM].cta[REJECT]:
      return Ids.DISMISS_SUGGESTION
    default:
      return Ids.IGNORE_BUTTON
  }
}

export const getPlagiarismCheckIconId = (status: Status) => {
  switch (status) {
    case COMPLETED:
      return Ids.PLAGIARISM_CHECK_SUCCESS_CHECKMARK
    case FAILED:
      return Ids.PLAGRIARISM_CHECK_FAILURE_X
    case RUNNING:
    default:
      return Ids.PLAGIARISM_CHECK_RUNNING_SPINNER
  }
}

export const getCardAcceptTestId = (acceptText: string, index?: number) => {
  let testId = ''

  switch (acceptText) {
    case cardText[LANGUAGE].cta[ACCEPT]:
      testId = Ids.EDIT_MY_TEXT_BUTTON
      break
    case cardText[PLAGIARISM].cta[ACCEPT]:
      testId = Ids.SEE_SOURCES
      break
    default:
      testId = Ids.FIX_IT_BUTTON
  }

  return index !== undefined ? `${testId}-${index}` : testId
}



// WEBPACK FOOTER //
// ./src/utils/dataTestIds/getters.ts